import { flow, uniq, get, tap, map, curry, keyBy } from 'lodash/fp';
import estimateLoaded from '../../estimateLoaded';
import loaded from '../../loaded';
import loading from '../../loading';
import globalError from '../../globalError';
import { createAndSendButtonSubmissionEventWithEventName } from '../../../analytics/commonAnalytics';
import AnalyticsConstants from '../../../analytics/constants';
import copyStyles from './prepareApiCall';
import clearCopyStylesSelection from '../clearCopyStylesSelection';

export default (sourceItemId, targetItemIds) => (dispatch, getState) => {
  dispatch(loading());
  const { estimateBuilder } = getState();

  const designId = get('uiState.selectedEstimate', estimateBuilder);
  const items = get('entities.items.byId', estimateBuilder);
  const containers = get('entities.containers.byId', estimateBuilder);

  const sourceItem = get(sourceItemId, items);
  const targetItems = map(get(curry.placeholder, items), targetItemIds);

  const containerIds = flow(map('containerId'), uniq)(targetItems);
  const targetContainers = flow(map(get(curry.placeholder, containers)), keyBy('containerId'))(containerIds);

  const itemsWithContainer = map(
    item => ({
      ...item,
      container: targetContainers[item.containerId],
    }),
    targetItems,
  );

  return copyStyles(designId, sourceItem, itemsWithContainer)
    .then(({ copyResults, design }) => {
      if (copyResults) {
        const copyErrors = copyResults.filter(r => !r.succeeded).length;
        if (copyErrors === 0) {
          createAndSendButtonSubmissionEventWithEventName(
            window.globalConfig.siteId,
            AnalyticsConstants.EventNames.DesignCopyStyle,
          );
        } else {
          dispatch(globalError());
        }
      }

      dispatch(clearCopyStylesSelection());
      dispatch(estimateLoaded(design));
    })
    .then(tap(() => dispatch(loaded())))
    .catch(({ err }) => dispatch(globalError({ err })));
};
